import React, { useEffect, useState } from "react";
import { Button, Modal, Select, Form } from "antd";
import { roomBookingApi } from "../../api";
import toast from "react-hot-toast";
import {
  ADMIN_RELEASE_REASONS,
  MONTHLY_ADMIN_RELEASE_LIMIT,
} from "../../utils/Constants";
import { employeeId } from "../../userRole";

const ReleaseRoomPopup = ({
  open,
  modalData,
  onCancel,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [quota, setQuota] = useState({
    used: 0,
    limit: MONTHLY_ADMIN_RELEASE_LIMIT,
    remaining: MONTHLY_ADMIN_RELEASE_LIMIT,
  });

  useEffect(() => {
    if (!open || !employeeId) return;
    form.resetFields();
    roomBookingApi
      .getAdminReleaseQuota(employeeId)
      .then((res) => {
        if (res?.data) setQuota(res.data);
      })
      .catch(() => {});
  }, [open, form]);

  const releasesExhausted = quota.remaining < 1;

  const releaseRoom = async (values) => {
    if (releasesExhausted) {
      toast.error(
        `No admin room releases left this month (${quota.used}/${quota.limit} used).`
      );
      return;
    }
    const toastId = toast.loading("Releasing room...");
    setLoading(true);
    try {
      await roomBookingApi.adminReleaseRoom(modalData.rtId, {
        releasedBy: employeeId,
        releaseReason: values.releaseReason,
      });
      onSuccess?.();
      toast.success("Room released successfully");
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        "Error releasing room";
      toast.error(typeof msg === "string" ? msg : "Error releasing room");
    }
    setLoading(false);
    toast.dismiss(toastId);
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title="Release this meeting room?"
      footer={null}
      destroyOnClose
      centered
      width={420}
      className="release-room-modal"
      maskClosable={!loading}
      styles={{
        body: { paddingTop: 8 },
      }}
    >
      <p style={{ color: "#595959", marginBottom: 8 }}>
        This frees the slot for others. Original booker:{" "}
        <strong>
          {modalData?.originalBookerName &&
          modalData.originalBookerName !== modalData?.originalBooker
            ? `${modalData.originalBookerName} (${modalData.originalBooker})`
            : modalData?.originalBooker || modalData?.originalBookerName}
        </strong>
      </p>
      <p style={{ color: "#595959", marginBottom: 12, fontSize: 13 }}>
        Admin room releases left this month:{" "}
        <strong>
          {quota.remaining}/{quota.limit}
        </strong>{" "}
        (used {quota.used}).
      </p>
      {releasesExhausted && (
        <div
          style={{
            marginBottom: 16,
            padding: "8px 12px",
            background: "#fff2f0",
            border: "1px solid #ffccc7",
            borderRadius: 6,
            fontSize: 13,
            color: "#cf1322",
            lineHeight: 1.45,
          }}
        >
          No releases left for this month. Each admin may release up to{" "}
          {quota.limit} booked rooms per month.
        </div>
      )}
      <Form form={form} layout="vertical" onFinish={releaseRoom} requiredMark>
        <Form.Item
          name="releaseReason"
          label="Reason"
          rules={[{ required: true, message: "Please select a release reason" }]}
          style={{ marginBottom: 20 }}
        >
          <Select
            placeholder="Select reason"
            options={ADMIN_RELEASE_REASONS}
            disabled={releasesExhausted}
          />
        </Form.Item>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "0.8rem",
          }}
        >
          <Button onClick={onCancel} disabled={loading}>
            Cancel
          </Button>
          <Button
            type="primary"
            danger
            htmlType="submit"
            loading={loading}
            disabled={releasesExhausted}
          >
            Release room
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ReleaseRoomPopup;
